export default "__VITE_ASSET__CwZgu70g__"